export default "__VITE_ASSET__BMm8jtdq__"